var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "packages-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 85,
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "项目名称", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入项目名称",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 45,
                            label: "标签",
                            prop: "flag",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入标签",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.flag,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "flag", $$v)
                              },
                              expression: "edit.flag",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 45,
                            label: "编码",
                            prop: "code",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入编码",
                              maxlength: "100",
                              disabled: "",
                            },
                            model: {
                              value: _vm.edit.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "code", $$v)
                              },
                              expression: "edit.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "项目类型", prop: "type" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.projectType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "projectType", $$v)
                                },
                                expression: "edit.projectType",
                              },
                            },
                            _vm._l(_vm.enums.projectTypes, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 110,
                            label: "价格",
                            prop: "price",
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入价格",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "price", $$v)
                              },
                              expression: "edit.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "必填限制", prop: "isRequired" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.isRequired,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "isRequired", $$v)
                                },
                                expression: "edit.isRequired",
                              },
                            },
                            _vm._l(_vm.isRequiredList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 110,
                            label: "小程序显示",
                            prop: "isShow",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.isShow,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "isShow", $$v)
                                },
                                expression: "edit.isShow",
                              },
                            },
                            _vm._l(_vm.isShowList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "体检项目", prop: "type" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.isPhysical,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "isPhysical", $$v)
                                },
                                expression: "edit.isPhysical",
                              },
                            },
                            _vm._l(_vm.enums.pysicalList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "业务类型", prop: "businessType" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.businessType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "businessType", $$v)
                                },
                                expression: "edit.businessType",
                              },
                            },
                            _vm._l(_vm.businessTypeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "8" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "type", $$v)
                                },
                                expression: "edit.type",
                              },
                            },
                            _vm._l(
                              _vm.enums.physicalProjectTypes,
                              function (item) {
                                return _c(
                                  "Option",
                                  {
                                    key: item.value,
                                    attrs: { value: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.enums.status, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 110,
                            label: "自动更新检查",
                            prop: "inspectStatus",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.inspectStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "inspectStatus", $$v)
                                },
                                expression: "edit.inspectStatus",
                              },
                            },
                            _vm._l(_vm.inspectStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              rows: 2,
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "项目告知书" } },
                        [
                          _c(
                            "el-upload",
                            {
                              class: { hideUpload: _vm.hideUpload },
                              attrs: {
                                action: "#",
                                limit: 1,
                                "file-list": _vm.fileList,
                                "list-type": "picture-card",
                                "auto-upload": false,
                                "on-change": _vm.handleChange,
                                "on-preview": _vm.handlePreview,
                                "on-remove": _vm.handleRemove,
                                "before-upload": _vm.beforeAvatarUpload,
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip",
                                },
                                [
                                  _vm._v(
                                    "只能上传png/jpg/jpeg文件，且大小不超过500MB"
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "Modal",
                            {
                              attrs: {
                                width: "50%",
                                title: "预览",
                                styles: { top: "60px" },
                                footerHide: true,
                              },
                              model: {
                                value: _vm.dialogVisible,
                                callback: function ($$v) {
                                  _vm.dialogVisible = $$v
                                },
                                expression: "dialogVisible",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  display: "block",
                                  "max-width": "100%",
                                  margin: "0px auto",
                                },
                                attrs: { src: _vm.dialogImageUrl },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        [
                          _c("TabPanel", {
                            ref: "editTabPanel",
                            attrs: {
                              packagesIds: _vm.packagesIds,
                              fieldIds: _vm.fieldIds,
                            },
                            on: {
                              "on-packagesIds": _vm.setPackagesIds,
                              "on-fieldIds": _vm.setFieldIds,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }